import axios, { axiosCallNestPublic } from "../utills/axios";
import { BROWSER_TEST } from "./types";
import { BROWSER_TEST_PROGRESS, OTHER_COUNTRY } from "./constants";
import { Upload } from "@aws-sdk/lib-storage";
import { S3Client } from "@aws-sdk/client-s3";
import { XhrHttpHandler } from "@aws-sdk/xhr-http-handler";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { getGetParams, getRandomID, getFileSizeInMB } from "../utills/common";

const headers = {
  headers: {
    HTTP_X_USERNAME: process.env.REACT_APP_HTTP_X_USERNAME,
    HTTP_X_PASSWORD: process.env.REACT_APP_HTTP_X_PASSWORD,
  },
};

// Axios call
const axiosCall = (url, data, method = "post", headers = { headers: {} }) => {
  return new Promise((resolve, reject) => {
    axios[method](url, data, headers)
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err));
  });
};

export const getScreenerSetId = (testId, is_published) => async (dispatch) => {
  dispatch({ type: BROWSER_TEST.UPDATE, payload: { isLoading: true } });

  try {
    const result = await axios.post("task/getScreenerSetId", { test_id: testId, published: Number(is_published) });
    const { error = null, isScreener = null, setId = null, screenerDraftId = null } = result?.data;

    if (!error) {
      dispatch({
        type: BROWSER_TEST.UPDATE,
        payload: {
          error: null,
          isLoading: false,
          isScreener,
          screenerSetId: setId,
          screenerDraftId,
          progress: isScreener ? BROWSER_TEST_PROGRESS.SCREENER : BROWSER_TEST_PROGRESS.NDA,
        },
      });
    } else {
      dispatch({
        type: BROWSER_TEST.UPDATE,
        payload: {
          error: { status: 400, message: error },
          isLoading: false,
          isScreener: null,
          screenerSetId: null,
          screenerResponseId: null,
          screenerDraftId: null,
        },
      });
    }
  } catch (error) {
    const { status, data } = error.response || {};
    const payload = { isLoading: false, error: { status, message: data?.error } };

    dispatch({ type: BROWSER_TEST.UPDATE, payload });
  }
};

export const listCountry = () => async (dispatch) => {
  dispatch({ type: BROWSER_TEST.UPDATE, payload: { isLoading: true, error: null } });

  try {
    const { data } = await axios.get(`user/listCountry`, headers);

    dispatch({ type: BROWSER_TEST.UPDATE, payload: { isLoading: false, countries: data } });
  } catch (error) {
    const { status, data } = error.response || {};
    const payload = { isLoading: false, error: { status, message: data?.error } };

    dispatch({ type: BROWSER_TEST.UPDATE, payload });
  }
};

export const loadPreviewFromWidgetData = (widgetData) => async (dispatch) => {
  dispatch({
    type: BROWSER_TEST.UPDATE,
    payload: {
      testDetails: widgetData?.data,
      error: null,
      isLoading: false,
      testDataFetched: true,
      previewError: false,
    },
  });
};

export const previewTest =
  (testId, published, password = null, lang = "en") =>
  async (dispatch) => {
    dispatch({ type: BROWSER_TEST.UPDATE, payload: { error: null, isLoading: true, testDataFetched: false, testDetails: null } });

    try {
      const { data } = await axios.post(`task/preview/`, { testId, published, password, no_recording: true, lang });
      // Add id to SUS questions if not present
      if (data?.data?.test && data?.data?.test?.susQuestions && data?.data?.test?.susQuestions.length > 0) {
        data.data.test.susQuestions = data?.data?.test?.susQuestions?.map((q) => ({
          ...q,
          id: q?.id || getRandomID(),
          options: q?.options?.map((o) => ({ ...o, id: o?.id || getRandomID() })),
        }));
      }

      dispatch({
        type: BROWSER_TEST.UPDATE,
        payload: {
          testDetails: data.data,
          error: null,
          isLoading: false,
          testDataFetched: true,
          previewError: false,
        },
      });
    } catch (error) {
      const { status, data } = error.response || {};
      const payload = {
        isLoading: false,
        error: { status, message: data?.error },
        testDetails: null,
        testDataFetched: true,
        previewError: true,
      };

      dispatch({ type: BROWSER_TEST.UPDATE, payload });
    }
  };

export const getLogId = (testId, requestObj = null, panel = null, lang = null, uxarmyUniqueId = null) => {
  if (!requestObj)
    requestObj = {
      test_id: testId,
      status: panel ? 0 : 1,
      name: "",
      email: "",
      gender: "U",
      dob: new Date().getFullYear(),
      nationality: OTHER_COUNTRY,
      user_id: panel,
      lang: lang,
      uxarmyUniqueId,
    };
  requestObj.redirect_params = getGetParams();

  return axiosCall("test/getLogId/", requestObj, "post", headers);
};

export const getTestDetails = (logId, lang) => {
  return axiosCall("test/getTestDetails/", { logID: logId, lang }, "post", headers);
};

export const getTaskDetails = (logID, taskID) => {
  return axiosCall("test/getTaskDetails", { logID, taskID }, "post", headers);
};

export const saveTestDetails = (data) => {
  return axiosCall("test/saveTestDetails", data, "post", headers);
};

export const saveVideoDetails = (data) => {
  return axiosCall("test/saveVideoDetails", data, "post", headers);
};

export const testComplete = (data) => {
  return axiosCall("user/testComplete", data, "post", headers);
};

export const checkBrowserTestAuth = (testId, lang, isPreview, isPublished, userId, uxarmyUniqueId = null) => {
  return axiosCall(
    "task/checkBrowserTestAuth",
    { test_id: testId, lang, is_preview: isPreview, is_published: isPublished, user_id: userId, uxarmy_unique_id: uxarmyUniqueId },
    "post"
  );
};

export const resetState = () => (dispatch) => dispatch({ type: BROWSER_TEST.RESET });

export const updateState = (payload) => (dispatch) => dispatch({ type: BROWSER_TEST.UPDATE, payload });

export const uploadVideoToS3 = async (file, awsParams, setUploadProgress) => {
  let prevProgress = 0;
  const { filePath, region, bucketName, identityPoolId } = awsParams;

  // Initialize the Amazon Cognito credentials provider
  const client = new S3Client({
    region,
    credentials: fromCognitoIdentityPool({
      identityPoolId: identityPoolId,
      client: new CognitoIdentityClient({ region }),
    }),
    requestHandler: new XhrHttpHandler({}),
    // CRITICAL: This is the only way to bypass the CRC32 part 1 error in newer SDKs
    requestChecksumCalculation: "WHEN_REQUIRED",
    responseChecksumValidation: "WHEN_REQUIRED",
  });

  // Upload Params
  const params = {
    Body: file,
    Key: filePath,
    Bucket: bucketName,
    ChecksumAlgorithm: null,
    ContentDisposition: "attachment",
    ContentType: file?.type ? file?.type?.split(";")[0] : "video/mp4",
  };

  try {
    // INITIATE UPLOAD
    const S3Upload = new Upload({
      client,
      params,
      queueSize: 4, // Upload 4 parts at once
      partSize: file?.size > getFileSizeInMB(500) ? getFileSizeInMB(20) : getFileSizeInMB(5), // 5MB for small & 20MB for files over 500MB
    });

    // Start tracking the UploadProgress
    S3Upload.on("httpUploadProgress", async (event) => {
      const progress = Math.min(parseInt(Math.round((event.loaded / event.total) * 100)), 100);
      if (!isNaN(progress) && progress > prevProgress) {
        prevProgress = progress;
        setUploadProgress(progress);
      }
    });

    return await S3Upload.done();
  } catch (e) {
    console.error("Error uploading video to S3:", e);
    return e;
  }
};

export const uploadIosVideoToS3 = async (file = null, awsParams = {}, setUploadProgress = () => {}) => {
  let prevProgress = 0;
  const { filePath } = awsParams;
  const contentType = file?.type ? file?.type?.split(";")[0] : "video/mp4";

  try {
    const { data } = await axiosCallNestPublic("public/get-signed-url", "post", { fileKey: filePath, contentType });

    // Upload the file using the signed URL
    return await axios.put(data?.url, file, {
      withCredentials: false,
      headers: { "Content-Type": contentType, "Content-Disposition": "attachment" },
      onUploadProgress: (progressEvent) => {
        const progress = Math.min(parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)), 100);
        if (!isNaN(progress) && progress > prevProgress) {
          prevProgress = progress;
          setUploadProgress(progress);
        }
      },
    });
  } catch (e) {
    console.error("Error uploading video to S3:", e);
    return e;
  }
};
